import React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Card } from '../Card';

const meta: Meta<typeof Card> = {
  title: 'Components/Card',
  component: Card,
};

export default meta;
type Story = StoryObj<typeof Card>;

export const Default: Story = {
  args: {
    header: 'Header goes here',
    children: (
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio consectetur nam vero recusandae maiores corporis,
        velit quae mollitia reprehenderit odit!
      </p>
    ),
  },
};

export const VariantMinimal: Story = {
  args: {
    header: 'Header goes here',
    children: (
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio consectetur nam vero recusandae maiores corporis,
        velit quae mollitia reprehenderit odit!
      </p>
    ),
    variant: 'minimal',
  },
};

export const VariantLayout: Story = {
  args: {
    header: 'Header goes here',
    children: (
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio consectetur nam vero recusandae maiores corporis,
        velit quae mollitia reprehenderit odit!
      </p>
    ),
    variant: 'layout',
  },
};
